import { render } from "./ClinicContactInfo.vue?vue&type=template&id=53216834&scoped=true&ts=true"
import script from "./ClinicContactInfo.vue?vue&type=script&lang=ts"
export * from "./ClinicContactInfo.vue?vue&type=script&lang=ts"

import "./ClinicContactInfo.vue?vue&type=style&index=0&id=53216834&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53216834"]])

export default __exports__